import type {DefaultTheme} from 'styled-components';

const GREEN_POSITION_MAX_PERCENT = 25;
const YELLOW_POSITION_MAX_PERCENT = 50;
const ORANGE_POSITION_MAX_PERCENT = 75;

/**
 * Color of the advert-position bar. The cheaper the car sits in its market
 * (lower percent), the greener the bar: ≤25 % green, ≤50 % yellow, ≤75 % orange,
 * the rest red.
 */
export function getPositionFillColor(theme: DefaultTheme, percent: number): string {
  if (percent <= GREEN_POSITION_MAX_PERCENT) {
    return theme.colors.palettes.green[60][100];
  }
  if (percent <= YELLOW_POSITION_MAX_PERCENT) {
    return theme.colors.palettes.yellow[60][100];
  }
  if (percent <= ORANGE_POSITION_MAX_PERCENT) {
    return theme.colors.palettes.orange[60][100];
  }
  return theme.colors.palettes.red[80][100];
}
